import { render, staticRenderFns } from "./DAdminIpRestriction.vue?vue&type=template&id=2c08370b&scoped=true&"
import script from "./DAdminIpRestriction.vue?vue&type=script&lang=js&"
export * from "./DAdminIpRestriction.vue?vue&type=script&lang=js&"
import style0 from "./DAdminIpRestriction.vue?vue&type=style&index=0&id=2c08370b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08370b",
  null
  
)

export default component.exports